import { render, staticRenderFns } from "./LayerPanel.vue?vue&type=template&id=5dc1fe7f&scoped=true"
import script from "./LayerPanel.vue?vue&type=script&lang=js"
export * from "./LayerPanel.vue?vue&type=script&lang=js"
import style0 from "./LayerPanel.vue?vue&type=style&index=0&id=5dc1fe7f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1fe7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc1fe7f')) {
      api.createRecord('5dc1fe7f', component.options)
    } else {
      api.reload('5dc1fe7f', component.options)
    }
    module.hot.accept("./LayerPanel.vue?vue&type=template&id=5dc1fe7f&scoped=true", function () {
      api.rerender('5dc1fe7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/LayerPanel.vue"
export default component.exports